import React from "react";
import { observer, inject } from "mobx-react";
import { withRouter } from "react-router-dom";
import { ReviewList, ReviewsLayout } from "ComponentsUI/Reviews";
import { replaceStaticHost } from "Helpers/ImageManager";

@withRouter
@inject("ApplicationModel")
@observer
export default class ReviewListContainer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			addedAnswers: [],
		};
	}

	succesfullyReplyCallback(data) {
		let answers = this.state.addedAnswers.slice(0);
		answers.push(data);
		this.setState({
			addedAnswers: answers,
		});
	}

	render() {
		let data = this.props.items.map((item) => {
			return {
				id: item.id,
				type: item.rating_type,
				name: item.author,
				rating: item.rating,
				views_all: item.views_all,
				// tags: ["Плохая техподдержка", "Сбои"],
				provider: {
					name: item.provider.name,
					city: item.region.name,
					area: "",
					logo: replaceStaticHost(item.provider.logo),
					url_name: item.provider.url_name,
					contacts: item.provider?.contacts,
				},
				header: item.title,
				text: item.review,
				services_of_use: item.services_of_use,
				time_of_use: item.time_of_use,
				like: "",
				likes: item.likes,
				dislike: "",
				real: item.real,
				date: item.date,
				answers: {
					count:
						item.answers.count +
						this.state.addedAnswers.filter((answer) => answer.review_id === item.id).length,
					list: [
						...item.answers.list,
						...this.state.addedAnswers.filter((answer) => answer.review_id === item.id),
					],
				},
				specifications: item.specifications,
				status: item.status,
			};
		});
		let {
			ApplicationModel: { ratesModel },
		} = this.props;

		if (ratesModel.reviewsOrientation) {
			return (
				<ReviewList
					data={data}
					withReply={this.props.withReply}
					succesfullyReplyCallback={(data) => this.succesfullyReplyCallback(data)}
				/>
			);
		} else {
			return <ReviewsLayout adBlock={true} items={this.props.items} />;
		}
	}
}
